// Charankako child theme scripts
// Compiled by Vite -> dist/main.js (npm run build)
// Enqueued by functions.php with filemtime() cachebusting.
// (SCSS is compiled separately via sass CLI, not imported here.)


document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('brx-header');
    if (!header) return;

    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;

        // 1. ZSUGORODÁS ÉS HÁTTÉRSZÍN (.scrolling osztály használata)
        if (currentScrollY > 50) {
            header.classList.add('scrolling');
        } else {
            header.classList.remove('scrolling');
        }

        // 2. FADE-OUT ELTŰNÉS (.fade-out-header)
        if (currentScrollY > 600) {
            if (currentScrollY > lastScrollY) {
                header.classList.add('fade-out-header');
            } else {
                header.classList.remove('fade-out-header');
            }
        } else {
            header.classList.remove('fade-out-header');
        }

        lastScrollY = currentScrollY;
    }, {passive: true});
});

document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', function () {
        if (window.scrollY > 500) {
            // Hozzáadjuk az osztályt a body-hoz
            document.body.classList.add('scrolled-past-500');
        } else {
            // Levesszük az osztályt a body-ról
            document.body.classList.remove('scrolled-past-500');
        }
    });
});
